import React from "react";
import { Helmet } from "react-helmet";

const Basic = () => (
  <Helmet>
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

    {
      // <!-- Google verification meta tag -->
    }
    <meta
      name="google-site-verification"
      content="1s3J5mLUF-OMyvEBMV0NVL4-sYgshiMOlP1XMqRrIeU"
    />
  </Helmet>
);

export default Basic;
